// extracted by mini-css-extract-plugin
export var createdDate = "_ng-1";
export var divider = "_ng-2";
export var headerDivider = "_ng-3";
export var messagesCard = "_ng-0";
export var messagesContainer = "_ng-7";
export var messagesContainerWrapper = "_ng-4";
export var pointerCapturingButtonBoxes = "_ng-a";
export var showLeftPanelButton = "_ng-9";
export var showMoreButton = "_ng-c";
export var showMoreButtonContainer = "_ng-b";
export var summaryTitle = "_ng-6";
export var systemMessageCardWrapper = "_ng-d";
export var topButtons = "_ng-8";
export var withPadding = "_ng-5";